import { EDITOR_DB_STATE } from "@/lib/state/reducers/editor-reducer";

import { RootState } from "../store";

export const savedLocallySelector = (state: RootState) => {
  if (state.editor.databaseState !== EDITOR_DB_STATE.SUPPORTED) {
    return "unsupported";
  }

  return state.editor.databaseSaveState;
};
